export var isImagePreview = function isImagePreview(preview) {
  return !!preview.dimensions;
};